import React, { useContext, useState } from "react";
import { assets } from "../assets/assets_frontend/assets";
import { AppContext } from "../context/AppContext";

const MyProfile = () => {
const {pic} =useContext(AppContext)
  const [userData, setUserData] = useState({ 
    
    name: "ebraheem gaber",
    image: pic,
    email: "ebraheemgaber222@gmail.com",
    phone: "01117646588",
    address: {
      line1: "awayed alex egypt",
      line2: "nasr city cairo egypt",
    },
    gender: "male",
    dob: "2000-09-27",
  });
  const [edit, setedit] = useState(false);
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setUserData((prev) => ({
          ...prev,
          image: reader.result, // ✅ only image changes
        }));
      };
      reader.readAsDataURL(file);
    }
  };
  return (
    <div className=" max-w-lg flex  flex-col">
      <div className="w-36 flex gap-4 items-center rounded-xl cursor-pointer">
        <img
          className=" h-36 rounded-2xl object-cover w-36 "
          src={userData.image}
          alt="jfnw"
        />
        {/* Hidden file input */}
        <input
          type="file"
          id="upload-photo"
          accept="image/*"
          onChange={handleFileChange}
          className="hidden"
        />
        {edit === true && (
          <label
            htmlFor="upload-photo"
            className="px-2  py-2 min-w-24 block rounded-lg bg-gray-200 font-medium cursor-pointer 
               hover:bg-gray-200 active:scale-95 shadow-md transition"
          >
            Edit Photo
          </label>
        )}{" "}
      </div>
      <div className=" flex flex-col gap-[1px] transition-all duration-1000 font-bold">
        <h1 className="font-bold text-lg mb-2">{userData.name}</h1>
        <p>contact information</p>
        <p>emai Id</p>
        {edit ? (
          <input
            className="bg-gray-200 py-2 rounded-md"
            value={userData.email}
            onChange={(e) => {
              setUserData((prev) => ({ ...prev, emai: e.target.value }));
            }}
          />
        ) : (
          <p className="py-2 font-normal">{userData.email}</p>
        )}
        <p>name</p>
        {edit ? (
          <input
            className="bg-gray-200  py-2 rounded-md"
            type="text"
            onChange={(e) => {
              setUserData((prev) => ({ ...prev, name: e.target.value }));
            }}
            value={userData.name}
          />
        ) : (
          <p className="font-normal py-2">{userData.name}</p>
        )}
        <p>phone number</p>
        {edit ? (
          <input
            className="bg-gray-200  py-2 rounded-md"
            type="text"
            onChange={(e) => {
              setUserData((prev) => ({ ...prev, phone: e.target.value }));
            }}
            value={userData.phone}
          />
        ) : (
          <p className="font-normal py-2">{userData.phone}</p>
        )}
        <p>birth date</p>
        {edit ? (
          <input
            className="bg-gray-200  py-2 rounded-md"
            type="date"
            onChange={(e) => {
              setUserData((prev) => ({ ...prev, dob: e.target.value }));
            }}
            value={userData.dob}
          />
        ) : (
          <p className="font-normal py-2">{userData.dob}</p>
        )}
        <p>gender</p>
        {edit ? (
          <select
            className="bg-gray-200 text-black  py-2 rounded-md"
            onChange={(e) => {
              setUserData((prev) => ({ ...prev, gender: e.target.value }));
            }}
            value={userData.gender}
          >
            <option value={"male"}>male</option>
            <option value={"female"}>female</option>
          </select>
        ) : (
          <p className="font-normal py-2">{userData.gender}</p>
        )}
      </div>

      {/* {edit?  <button className=" bg-primary rounded-lg p-1 w-16" onClick={()=>{setedit(false)}}>save</button>:<button className= "rounded-lg w-16 bg-primary p-1 w-15" onClick={()=>{setedit(true)}}>edit</button>}  */}
      <button
        className="mt-2  bg-primary rounded-lg p-1 w-16"
        onClick={() => {
          setedit(!edit);
        }}
      >
        {!edit ? "edit" : "save"}
      </button>
    </div>
  );
};

export default MyProfile;
